/**
 * Returns true when the given file name has a .pdf extension. File names in
 * the portal are sometimes URL encoded, so the name is decoded before checking
 * (falling back to the raw name when decoding throws).
 */
export function isPdfFileName(fileName: string | undefined | null): boolean {
  if (!fileName) return false

  let name = fileName
  try {
    name = decodeURIComponent(fileName)
  } catch (e) {
    // leave as-is
  }

  // Strip any query string or fragment that may have been carried along
  name = name.split(/[?#]/)[0]

  return /\.pdf$/i.test(name.trim())
}
